import React, { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import PageMenu from 'components/blocks/PageMenu/PageMenu'
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";
import { useParams } from 'react-router-dom';
import Loader from 'components/blocks/Loader/Loader';
import useGetCertificadoEmpresaItByID from 'services/record/CertificadoEmpresa/useGetCertificadoEmpresaItByID';
import { jwtDecode } from 'jwt-decode';
import useDecode from 'hooks/useDecode';
import useGetPagoUnicoCATAByID from 'services/record/PagoUnicoCATA/useGetPagoUnicoCATAByID';
import useGetPrestacionEconomicaRELByID from 'services/record/PrestacionEconomicaREL/useGetPrestacionEconomicaRELByID';
import ReanudacionCATA from './ReanudacionCATA';
import useGetReanudacionCATAByID from 'services/record/ReanudacionCATA/useGetReanudacionCATAByID';
interface Params {
    idprestacion: string;
    idform: string;
}


const HistorialReanudacionCATA = () => {
    const decoded = useDecode("token");
    const [data, setData] = useState(null);
    const navigate = useNavigate()
    const { dataGetReanudacionCATAByID, errorGetReanudacionCATAByID, getReanudacionCATAByID, loadingGetReanudacionCATAByID, successGetReanudacionCATAByID } = useGetReanudacionCATAByID();
    const { idprestacion, idform } = useParams<Record<string, string>>();


    useEffect(() => {
        const actualUrl = window.location.href;
        if (!actualUrl.includes('/mis-gestiones/formularios')) {
            const userId = decoded.extension_id;
            const prestacionId = idprestacion.split('_')[1];
            const formId = idform;

            getReanudacionCATAByID(userId, prestacionId, formId, setData);
        }
    }, []);

    return (
        <div>
            <PageMenu title={'Solicitud de reanudación de la prestación de cese de actividad'}>

                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>


            {
                loadingGetReanudacionCATAByID ?
                    <Loader activeLoader={true} label="Cargando Formulario"></Loader>
                    :
                    <ReanudacionCATA dataUser={data} info={false} />
            }




        </div>
    )
}

export default HistorialReanudacionCATA